import { render } from "./CreateSampleButton.vue?vue&type=template&id=e2f4531a"
import script from "./CreateSampleButton.vue?vue&type=script&lang=js"
export * from "./CreateSampleButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__